<template lang="html">
  <div class="">
    <h2>Offers</h2>
    <hr>
    <div class="">

      <div class="filter-form-field">
        <label for="">Offer ID:</label>
        <input v-model='filterForm.offerID' class="def">
      </div>

      <div class="filter-form-field">
        <label for="">OS:</label>
        <select class="def" v-model='filterForm.os'>
          <option value="">All</option>
          <option value="iOS">iOS</option>
          <option value="Android">Android</option>
        </select>
      </div>

      <div class="filter-form-field">
        <label for="">Geo:</label>
        <select class="def" v-model='filterForm.geo'>
          <option value="">All</option>
          <option :value='code' v-for='(country, code) in countryOptions'>
            {{country}}
          </option>
        </select>
      </div>

    </div>

    <br>
    <div class="sl-list" v-if='offers'>
      <ul class="sl-ul">
        <li class="sl-th">
          <span class="f-id">ID</span>
          <span class="f-title">Title</span>
          <span class="f-status">Status</span>
          <span class="f-actions">Actions</span>
        </li>

        <li class="sl-t" v-for='offer in offers'>
          <span class="f-id">
            {{offer.external_offer_id}}
          </span>
          <span class="f-title">
            {{offer.title}}
          </span>
          <span class="f-status po">
            <span class="status-btn" @click='toggleStatus(offer)'
            :class='{active: offer.status==="active", paused: offer.status==="paused"}'>
              {{offer.status}}
            </span>
          </span>
          <span class="f-actions">
            <!-- <button :disabled='offer.status==="active"' type="button" class="btn _btn-white">Push</button> -->
            <button type="button" class="btn _btn-white" @click='onPush(offer)'>Push</button>
            <button type="button" class="btn _btn-white" @click='onOptimizeClick(offer)'>Optimize</button>
          </span>
        </li>
      </ul>
    </div>

    <ScreenBlocker v-if='offerOptimizationDisplay' :onClose='e => {offerOptimizationDisplay = null}'>
      <OfferOptimization :offer='offerOptimizationDisplay' :onClose='e => {offerOptimizationDisplay = null}'></OfferOptimization>
    </ScreenBlocker>
  </div>
</template>

<script>
import countryOptions from '@/assets/countries.js'
import OfferOptimization from './OfferOptimization.man'
export default {
  components: {
    OfferOptimization
  },
  data() {
    return {
      _allOffers: null,
      offers: null,
      filterForm: {
        os: null,
        geo: null
      },
      offerOptimizationDisplay: null, // 1562904
      countryOptions
    }
  },
  watch: {
    ['filterForm.offerID']() {
      this.filterOffers()
    },
    ['filterForm.os']() {
      this.filterOffers()
    },
    ['filterForm.geo']() {
      this.filterOffers()
    }
  },
  methods: {
    onPush(offer) {
      let confirm = window.confirm(`Are you sure that you want to push offer '${offer.title}'?`)
      if(!confirm) {
        return
      }

      this.$http.post('affise/offers/push?externalOfferID=' + offer.external_offer_id)
        .then(() => {
          this.notifySuccess(`Pushed offer ${offer.title}`)
        })
        .catch(err => {
          this.notifyError("Could not push offer")
        })
    },
    toggleStatus(offer) {
      let status = offer.status
      let toStatus
      if(status === "active") {
        toStatus = "paused"
      } else {
        toStatus = "active"
      }

      let actionName = toStatus === "active" ? "activate" : "pause"
      let confirm = window.confirm("Are you sure you want to " + actionName + " this campaign?")
      if(!confirm) {
        return
      }
      this.$http.put('affise/offers/status?status=' + toStatus + '&externalOfferID=' + offer.external_offer_id)
        .then(() => {
          offer.status = toStatus
        })
        .catch(err => {
          this.notifyError("Could not update offer status")
        })

    },
    onOptimizeClick(offer) {
      this.offerOptimizationDisplay = offer
    },
    filterOffers() {
      let _allOffers = this._allOffers
      let filterForm = this.filterForm
      let {os, geo, offerID} = filterForm
      let offers = _allOffers.slice(0)
      if(os) {
        offers = offers.filter(v => {
          let payments = v.payments
          if(!payments || payments.length === 0) {
            return false
          }
          let payments1Os = payments[0].os
          if(!payments1Os || payments1Os.length === 0) {
            return false
          }
          return payments1Os.includes(os)
        })
      }

      if(geo) {
        offers = offers.filter(v => {
          let payments = v.payments
          if(!payments || payments.length === 0) {
            return false
          }
          for (let i = 0; i < payments.length; i++) {
            let paymentCountries = payments[i].countries
            if(!paymentCountries || paymentCountries.length === 0) {
              continue
            }
            if(paymentCountries.includes(geo)) {
              return true
            }
          }
          return false
        })
      }

      if(offerID) {
        offers = offers.filter(v => v.external_offer_id.includes(offerID))
      }

      this.offers = offers
    }
  },
  created() {
    this.$http.get("affise/offers")
      .then(r => r.json())
      .then(offers => {
        this._allOffers = offers
        this.filterOffers()
      })
  }
}
</script>

<style lang="css" scoped>

.sl-list {
  display: flex;
  flex-direction: column;
  border: 1px solid gainsboro;
  border-bottom: 0;
}
.sl-list .sl-th {
  background: #ededed;
  position: sticky;
  top: 0;
  font-weight: bold;
  color: #4d4d4d;
  font-size: 14px;
  z-index: 5;
}
.sl-list li {
  border-bottom: 1px solid #d2d2d2;
  display: flex;
  font-size: 14px;
  font-weight: bold;
  color: #5a5a5a;
}
.sl-list li.sl-t:hover {
  background: #f5f5f5;
}
.sl-list .sl-th span {
  /* font-weight: bold; */
}
.sl-list li span {
  padding-left: 11px;
  border-right: 1px solid gainsboro;
  padding: 4px 4px 4px 9px;
}
.sl-ul {
  max-height: 70vh;
  overflow-y: auto;
  position: relative;
}
.status-btn {
  background: white;
  border: 1px solid gainsboro;
  border-radius: 2px;
  padding: 1px 12px;
  font-size: 11px;
  width: 76px;
  text-transform: uppercase;
}
.status-btn.active {
  background: #ffffff;
  border: 1px solid #b3e4b3;
  font-weight: bold;
  color: #3e7727;
}
.status-btn.paused {
  background: #ffffff;
  border: 1px solid #d2d2d2;
  font-weight: bold;
  color: #6b6b6b;
}
.po {
  cursor: pointer;
}
.f-id {
  width: 140px;
}
.f-title {
  width: 420px;
}
.f-status {
  width: 100px;
}
.f-actions {
  width: 230px;
}
.filter-form-field {
  margin-right: 15px;
  display: inline;
}
.filter-form-field label {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/management/campaigns/campaigns.man.vue